import { render } from "./UserDetailsFullscreenModal.vue?vue&type=template&id=5135241a"
import script from "./UserDetailsFullscreenModal.vue?vue&type=script&lang=js"
export * from "./UserDetailsFullscreenModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__